import { fetchUtils } from 'react-admin';

// export const url_api = "http://localhost/sbm-api/api.php";
// export const url_login = "http://localhost/sbm-api/api/login.php";
// export const url_download_template = "http://localhost/sbm-api/template-mitra.xlsx";
// export const url_download_template_sbml = "http://localhost/sbm-api/template-sbml.xlsx";

// export const url_api = "http://192.168.1.6/sbm-api/api.php";
// export const url_login = "http://192.168.1.6/sbm-api/api/login.php";
// export const url_download_template = "http://192.168.1.6/sbm-api/template-mitra.xlsx";
// export const url_download_template_sbml = "http://192.168.1.6/sbm-api/template-sbml.xlsx";

export const url_api = "https://sultradata.com/project/antrian-api/api.php";
export const url_login = "https://sultradata.com/project/antrian-api/api/login.php";
export const url_download_template = "https://sultradata.com/project/antrian-api/template-mitra.xlsx";
export const url_download_template_sbml = "https://sultradata.com/project/antrian-api/template-petugas-pst.xlsx";
export const url_download_template_piket = "https://sultradata.com/project/antrian-api/template-petugas-pst.xlsx";
export const url_download_panduan = "https://sultradata.com/project/antrian-api/panduan-sibakti-mitra.pdf";
export const url_image = "https://sultradata.com/project/antrian-api/";


export const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    // add your own headers here
    let jwt = ""
    let storage = localStorage.getItem("antrian-auth");
    if (storage !== null) {
      let temp = JSON.parse(storage);
      jwt = temp.jwt;
    }
    // options.headers.set('X-Authorization', 'Bearer '+"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJUSEVfSVNTVUVSIiwiYXVkIjoiVEhFX0FVRElFTkNFIiwiaWF0IjoxNjU4NzIwMzY3LCJuYmYiOjE2NTg3MjAzNjgsImV4cCI6MTY1ODcyNzU2NywiZGF0YSI6eyJ1c2VybmFtZSI6ImFkbWluIiwicm9sZSI6IjEiLCJrb2RlX3dpbGF5YWgiOiI3NDAyIn19.QNkbwcSoiS1jStZvEd7M6in4zHY6eblhlcfPRWQ6yPQ");
    options.headers.set('X-Authorization', 'Bearer '+jwt);
    return fetchUtils.fetchJson(url, options);
  };

  export const getAuthData = () => {
    let storage = localStorage.getItem("antrian-auth");
    if (storage !== null) {
        let temp = JSON.parse(storage);
        return temp;
    }
    return null;
}